import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header-intro theme-bg-primary text-white py-5" }
const _hoisted_2 = { class: "container text-center" }
const _hoisted_3 = { class: "page-heading mb-1" }
const _hoisted_4 = { class: "page-heading-tagline mx-auto mb-3" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "profile-small d-inline-block rounded-circle mb-3",
  src: "/images/profile.png",
  alt: ""
}, null, -1)
const _hoisted_6 = { class: "page-heading-post-meta list-inline mb-0" }
const _hoisted_7 = { class: "list-inline-item me-3" }
const _hoisted_8 = { class: "list-inline-item" }
const _hoisted_9 = /*#__PURE__*/_createVNode("a", {
  class: "text-link",
  href: "#comments-block"
}, "8 Comments", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.blogPost.title), 1),
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.blogPost.tagline), 1),
      _hoisted_5,
      _createVNode("ul", _hoisted_6, [
        _createVNode("li", _hoisted_7, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'clock'],
            class: "me-2"
          }),
          _createTextVNode(_toDisplayString(_ctx.blogPost.publishedAt.toDateString()), 1)
        ]),
        _createVNode("li", _hoisted_8, [
          _createVNode(_component_font_awesome_icon, {
            icon: "comment",
            class: "me-2"
          }),
          _hoisted_9
        ])
      ])
    ])
  ]))
}